import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Dispatch } from 'redux';
import {
  AddressingActions,
  ApplicationState,
  SlidePanelContent,
  SlidePanelPosition,
  SlidePanelSide,
  TimelineActions
} from '../../store/';
import { filterButtonContentSelector } from '../../store/selectors';
import Navbar, { NavbarActions, NavbarProps } from './Navbar';

export const mapStateToProps: MapStateToProps<NavbarProps, any, ApplicationState> = (state, _) => {
  const { preset } = state.timeline;

  return {
    preset,
    filters: filterButtonContentSelector(state)
  };
};

export const mapDispatchToProps: MapDispatchToProps<NavbarActions, any> = (dispatch: Dispatch, _) => {
  return {
    openFilters: () =>
      dispatch(
        TimelineActions.setSlidePanelPositionAndContent(
          SlidePanelPosition.Opened,
          SlidePanelContent.Filters,
          SlidePanelSide.Left
        )
      ),
    clearFilters: () => dispatch(AddressingActions.clearFilterValues())
  };
};

export const NavbarContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Navbar);



// WEBPACK FOOTER //
// ./src/components/navbar/NavbarContainer.ts